import * as actions from './shared-auth-state.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SpxStorage, SpxStorageKeyEnum } from '@softpak/components/spx-storage';

import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedStorageKeyEnum } from 'src/app/shared/_config/storage/shared-storage-key-enum';
import { mergeMap } from 'rxjs/operators';
import { sharedEnvironmentActions } from '../shared-environment-info';
import { sharedGetDepotActions } from '../shared-get-depot';
import { sharedGetEquipmentActions } from '../shared-get-equipment';
import { sharedSetDepotActions } from '../shared-set-depot';
import { sharedSetEquipmentActions } from '../shared-set-equipment';
import { spxToasterActions } from '@softpak/components/spx-toaster';
import { valuePairToValue } from '@softpak/components/spx-helpers';

@Injectable()
export class SharedAuthStateEffects {
  private readonly actions$ = inject(Actions);

  afterSet$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.signedIn),
      mergeMap(() => {
        const depotCode = SpxStorage.getChannelSetting<string>(
          SharedStorageKeyEnum.depot
        );
        const equipmentCode = SpxStorage.getChannelSetting<string>(
          SharedStorageKeyEnum.equipment
        );
        return [
          sharedEnvironmentActions.load({}),
                sharedGetDepotActions.load({}),
                sharedGetEquipmentActions.load({}),
                depotCode ?
                    sharedSetDepotActions.load({
                        query: {
                            depotCode: valuePairToValue(depotCode)
                        }
                    }) : undefined,
                equipmentCode ?
                    sharedSetEquipmentActions.load({
                        query: {
                            equipmentCode: valuePairToValue(equipmentCode)
                        }
                    }) : undefined,
        ].filter((x) => x !== undefined);
      })
    )
  );

  afterSignOut$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.signOut),
      mergeMap(() => {
        SpxStorage.setChannelSetting<SharedStorageKeyEnum>(
          SpxStorageKeyEnum.token,
          undefined
        );
        // this.router.navigate([
        //   navConstants.navHmeSignInUrl
        // ]);
        return [
          spxToasterActions.clearAllErrors(),
          sharedGetDepotActions.reset({}),
          sharedGetEquipmentActions.reset({}),
          sharedEnvironmentActions.reset({}),
        ];
      })
    )
  );
}
